﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow, loaderHide} from "./loader";
import {serializeProductSearchForm} from "./product-search-push-state";

let refineResultStack = [];
// const refineResultDataSourceSelector = $('#offcanvasRefineResults .offcanvas-body.result-body li[data-source]');

let currentKey = '';

const containerSelector = '[product-filter-off-canvas]';

function getContainer() {
    return $(containerSelector);
}

let container = getContainer();


function refreshTemplates() {
    $('[data-off-canvas-template-key]').each((index, element) => {
        let block = $(element);
        const key = block.data('off-canvas-template-key');
        const template = $($(`#${key}`).html());
        block.replaceWith(template);
    });
    loaderHide(containerSelector);
}

export function updateOffCanvasRoot(html) {
    let root = $('[data-product-filter-off-canvas-root]');
    const newHtml = $(html);
    root.replaceWith(newHtml);
    refreshTemplates();
    updateZIndexesInRefineResults();
}

function removeHideClass(html) {
    setTimeout(() => {
        html.removeClass('hide');
    }, 20)
}

function appendTemplateToRefineResults(key) {
    const template = $(`#${key}`);
    const html = $(template.html());
    html.addClass('hide');
    container.append(html);
    updateZIndexesInRefineResults();
    removeHideClass(html);
}

function updateZIndexesInRefineResults() {
    $(containerSelector).children().each((index, element) => {
        let block = $(element);
        block.css('z-index', index);
    });
}

function removeTemplate(element) {
    element.addClass('hide');
    setTimeout(() => {
        element.remove();
        updateZIndexesInRefineResults();
    }, 500);
}

function removeLastTemplateFromRefineResults() {
    const topLevel = container.children().last();
    removeTemplate(topLevel);
}

function removeTemplateViewsFromRefineResults() {
    $('[data-off-canvas-template-key]').remove();
}

export function initiateRefineResults() {

    if (!container.length) {
        return;
    }

    container[0].addEventListener('show.bs.offcanvas', event => {
        removeTemplateViewsFromRefineResults();
    });
    $(document).on('click', '[data-product-filter]', function (e) {
        const key = $(this).data('product-filter');
        currentKey = key;

        appendTemplateToRefineResults(key);
    });
    $(document).on('click', '[data-product-filter-back]', function (e) {
        removeLastTemplateFromRefineResults();
    });
    $(document).on('change', `${containerSelector} input`, function (e) {
        const input = $(this);
        // get the id and strip out the suffix
        const mainCheckboxId = input.attr('id')?.replace('-offcanvasfilter', '') ?? '';
        // if we can't find the main checkbox, bail
        if (!mainCheckboxId) {
            return;
        }

        const checked = input.is(':checked');
        $(`#${mainCheckboxId}`).prop('checked', checked).trigger('change');
        loaderShow(containerSelector);
    });
    $(document).on('click', `${containerSelector} [data-prefill-range]`, async function (e) {
        e.preventDefault();
        
        let link = $(this);
        let context = link.closest('[data-off-canvas-range-context]');
        const propertyName = link.data('prefill-range');
        const from = link.data('prefill-range-from');
        const to = link.data('prefill-range-to');

        // set the values
        context.find(`input[name="${propertyName}|From"]`).val(from);
        context.find(` input[name="${propertyName}|To"]`).val(to);

        // trigger the filter
        context.find('[data-range-update]').trigger('click');
    })
    $(document).on('click', `${containerSelector} [data-range-update]`, async function (e) {
        const button = $(this);

        const context = button.closest('[data-off-canvas-range-context]');

        const mainForm = $('[product-search-form]');

        // for each input in the context, set the value on the main form
        context.find('input').each((index, element) => {
            const input = $(element);
            const name = input.attr('name');
            const value = input.val();
            mainForm.find(`[name="${name}"]`).val(value);
        });

        loaderShow(containerSelector);
        
        await serializeProductSearchForm(mainForm);
    });
}